export default {"src":"/_next/static/media/portfolio-catapult-header-light-theme.251d87cd.svg","height":100,"width":330};